/** Full-viewport loading state used by the route guards and the SSO callback. */

export function FullPageSpinner({ label = 'Loading…' }: { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="h-full min-h-screen flex flex-col items-center justify-center gap-3 bg-surface-50 dark:bg-surface-950"
    >
      <span className="h-8 w-8 rounded-full border-2 border-surface-300 border-t-primary-500 animate-spin dark:border-surface-700 dark:border-t-primary-400" />
      <p className="text-sm text-surface-500 dark:text-surface-400">{label}</p>
    </div>
  );
}
